import { motion } from "framer-motion";

const stats = [
  { value: "99%+", label: "Purity" },
  { value: "500+", label: "Athletes trust us" },
  { value: "50+", label: "Products available" },
  { value: "100%", label: "Genuine grade" },
];

export const Stats = () => {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 border-y border-[#29FF87]/15 bg-[#0B120B]" data-testid="stats-section">
      <div className="max-w-[1600px] mx-auto">
        <p className="font-grotesk font-bold uppercase tracking-[0.3em] text-[#29FF87] text-xs mb-3">Quality standards</p>
        <h2 className="font-grotesk font-extrabold uppercase text-3xl md:text-5xl text-white tracking-tight mb-14">Built on science. <span className="glow-green">Driven by quality.</span></h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
              data-testid={`stat-${i}`}
            >
              <p className="font-grotesk font-extrabold text-5xl md:text-6xl glow-green">{s.value}</p>
              <p className="mt-2 font-body text-xs uppercase tracking-[0.25em] text-[#7BC79A]">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
